module.exports = __webpack_public_path__ + "static/img/hader_bg.7d009db.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about_company/profile/hader_bg.png
// module id = bqle
// module chunks = 1